import React, { Component } from "react";
import { hasWebDerivative } from "./embedMedia";

/**
 * Presentacional del embed: pinta imagen, video o un placeholder.
 * Sin redux y sin intl a propósito — esto se renderiza en el sitio de un
 * cliente y el store persistido puede traer mensajes viejos (store/index.js
 * invalida por versión), lo que dejaría ids de traducción crudos a la vista.
 */
class EmbedViewer extends Component {
  constructor(props) {
    super(props);
    this.state = { src: props.media.src, retried: false, failed: false };
  }

  componentDidUpdate(prevProps) {
    if (prevProps.media.src !== this.props.media.src) {
      this.setState({ src: this.props.media.src, retried: false, failed: false });
    }
  }

  handleMediaError = () => {
    const { data } = this.props;
    const { retried, src } = this.state;

    // Una extensión mal clasificada puede pasar el filtro y aun así no
    // decodificar. Un reintento con el derivado web y listo: nada de loops
    // dentro de la página de un cliente.
    if (!retried && hasWebDerivative(data) && src !== data.mediaQualityURL) {
      this.setState({ src: data.mediaQualityURL, retried: true });
      return;
    }
    this.setState({ failed: true });
  };

  renderPlaceholder() {
    const { data } = this.props;
    const url = data && data.originalURL;

    return (
      <div className="bk-embed__placeholder">
        <span>Este archivo no se puede previsualizar aquí.</span>
        {url && (
          <a href={url} target="_blank" rel="noopener noreferrer">
            Abrir archivo
          </a>
        )}
      </div>
    );
  }

  render() {
    const { media, data } = this.props;
    const { src, failed } = this.state;

    if (failed || media.kind === "unsupported" || !src) {
      return this.renderPlaceholder();
    }

    if (media.kind === "video") {
      return (
        <video
          className="bk-embed__media"
          src={src}
          controls
          playsInline
          preload="metadata"
          onError={this.handleMediaError}
        />
      );
    }

    return (
      <img
        className="bk-embed__media"
        src={src}
        alt={(data && data.name) || ""}
        onError={this.handleMediaError}
      />
    );
  }
}

export default EmbedViewer;
